import React from 'react';
import { Trans } from 'react-i18next';
import i18n from '../i18n';
import { SigninLink } from '../components/auth/SigninLink';
import { Icon } from '@homeexchange/design';

export default class HandleErrors {
    static renderErrors(errorsEntity, message, logIn = false) {
        function signIn() {
            document.dispatchEvent(new CustomEvent('open_signin_popup'));
        }

        return (
            errorsEntity && (
                <div className="form-errors">
                    <span role="alert">
                        <Icon name="ExclamationCircleOutline" color="error" />
                        {logIn ? (
                            <Trans
                                i18nKey="common:email_not_unique"
                                components={
                                    <SigninLink
                                        onClick={signIn}
                                        text="email_not_unique_redirect_login_link"
                                    />
                                }
                                i18n={i18n}
                            />
                        ) : (
                            message
                        )}
                    </span>
                </div>
            )
        );
    }
}
